<script lang="ts" setup>
import SignaturePad from "@/components/SignaturePad.vue"
import { DateTime } from "luxon"
import { computed, ref, watch } from "vue"

const props = defineProps<{
    formElement: any
    city?: string
    signature?: string
}>()
const emit = defineEmits<{
    (e: "update:city", city: string): void
    (e: "update:signature", signature: string): void
    (e: "empty", isEmpty: boolean): void
}>()

const signature = ref(props.city || "")
const city = ref(props.signature || "")
const date = ref(DateTime.now().toFormat("dd.LL.yyyy"))

watch(signature, value => {
    emit("update:signature", value)
})
watch(city, value => {
    emit("update:city", value)
})

/*
 * Emptiness detection
 */
const isSignatureEmpty = ref(true)
const isCityEmpty = computed(() => !city.value)

function onSignatureEmpty(isEmpty: boolean) {
    isSignatureEmpty.value = isEmpty
}

watch([isSignatureEmpty, isCityEmpty], ([isSignatureEmpty, isCityEmpty]) => {
    emit("empty", isSignatureEmpty || isCityEmpty)
})
</script>

<template>
    <div>
        <label class="d-block font-weight-bold">{{ formElement.text }}</label>
        <div class="mb-3">
            <div class="">{{ $t("@cms:onlineForm.signature.date") }}</div>
            <input
                type="text"
                class="border-0 bg-light"
                :name="'signatures[' + formElement.key + '][date]'"
                disabled
                readonly
                v-model="date"
                style="width: 400px"
            />
        </div>
        <div class="mb-3">
            <div class="">{{ $t("@cms:onlineForm.signature.city") }}</div>
            <input
                type="text"
                class="border-0 bg-light"
                :name="'signatures[' + formElement.key + '][city]'"
                v-model="city"
                style="width: 400px"
            />
        </div>
        <div class="h-100">
            <div class="signature-label-signature">
                {{ $t("@cms:onlineForm.signature.signature") }}
            </div>
            <SignaturePad v-model="signature" @empty="isEmpty => onSignatureEmpty(isEmpty)"></SignaturePad>
        </div>
        <input type="hidden" :name="'signatures[' + formElement.key + '][image]'" :value="signature" />
    </div>
</template>
